module.exports = __webpack_public_path__ + "static/img/piliangshanchu.a2dbe2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/piliangshanchu.png
// module id = N3ko
// module chunks = 24